import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EnableTwoFaMutationVariables = Types.Exact<{
  secret: Types.Scalars['String']['input'];
  code: Types.Scalars['String']['input'];
}>;


export type EnableTwoFaMutationPage = { readonly __typename?: 'RootMutationType', readonly enable2fa: { readonly __typename?: 'AccountsUser', readonly id: string } };

export type DisableTwoFaMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DisableTwoFaMutationPage = { readonly __typename?: 'RootMutationType', readonly disable2fa: { readonly __typename?: 'AccountsUser', readonly id: string } };


export const EnableTwoFaDocument = gql`
    mutation EnableTwoFa($secret: String!, $code: String!) {
  enable2fa(secret: $secret, code: $code) {
    id
  }
}
    `;
export type EnableTwoFaMutationFn = Apollo.MutationFunction<EnableTwoFaMutationPage, EnableTwoFaMutationVariables>;

/**
 * __useEnableTwoFaMutation__
 *
 * To run a mutation, you first call `useEnableTwoFaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableTwoFaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableTwoFaMutation, { data, loading, error }] = useEnableTwoFaMutation({
 *   variables: {
 *      secret: // value for 'secret'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEnableTwoFaMutation(baseOptions?: Apollo.MutationHookOptions<EnableTwoFaMutationPage, EnableTwoFaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableTwoFaMutationPage, EnableTwoFaMutationVariables>(EnableTwoFaDocument, options);
      }
export type EnableTwoFaMutationHookResult = ReturnType<typeof useEnableTwoFaMutation>;
export type EnableTwoFaMutationResult = Apollo.MutationResult<EnableTwoFaMutationPage>;
export type EnableTwoFaMutationOptions = Apollo.BaseMutationOptions<EnableTwoFaMutationPage, EnableTwoFaMutationVariables>;
export const DisableTwoFaDocument = gql`
    mutation DisableTwoFa {
  disable2fa {
    id
  }
}
    `;
export type DisableTwoFaMutationFn = Apollo.MutationFunction<DisableTwoFaMutationPage, DisableTwoFaMutationVariables>;

/**
 * __useDisableTwoFaMutation__
 *
 * To run a mutation, you first call `useDisableTwoFaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTwoFaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTwoFaMutation, { data, loading, error }] = useDisableTwoFaMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableTwoFaMutation(baseOptions?: Apollo.MutationHookOptions<DisableTwoFaMutationPage, DisableTwoFaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableTwoFaMutationPage, DisableTwoFaMutationVariables>(DisableTwoFaDocument, options);
      }
export type DisableTwoFaMutationHookResult = ReturnType<typeof useDisableTwoFaMutation>;
export type DisableTwoFaMutationResult = Apollo.MutationResult<DisableTwoFaMutationPage>;
export type DisableTwoFaMutationOptions = Apollo.BaseMutationOptions<DisableTwoFaMutationPage, DisableTwoFaMutationVariables>;